import { useState, useEffect } from 'react';
import { getMediaTypesURL } from '../utils/ConstantsURL';

export const useGetMediaTypes = (token) => {
  const [mediaTypes, setMediaTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMediaTypes = async () => {
      if (!token) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(getMediaTypesURL(), {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        
        const transformedData = data.map(item => ({
          id: item.FMECLAVE,
          name: item.FMEDESCRIPCION
        }));
        
        setMediaTypes(transformedData);
      } catch (error) {
        console.error('Error fetching media types:', error);
        setError(error.message);
        setMediaTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMediaTypes();
  }, [token]);

  return {
    mediaTypes,
    loading,
    error
  };
};
